<div class="quick-actions-main-container"
  #projectCard
  [ngClass]="{
      'open-left' : cardPositions.shouldOpenLeft,
      'open-from-bottom' : cardPositions.bottomScroll,
      'open-from-middle' : cardPositions.middleScroll,
      'loading-on' : !quickActionData
  }">
  <div class="header-actions-btns-container">
      <div (pointerdown)="gotToTeamDashboard()" class="go-to-team-btn">
          <span class="to-team-dashboard-text">{{'to_go_to_team_dashboard' | translate}}</span>
          <img class="diagonal-arrow" src="../../../../../assets/svg/diagonal-blue-arrow.svg">
      </div>
      <img class="quick-actions-close-btn"
          (pointerdown)="closeTeamQuickActions();$event.stopPropagation()"
          src="../../../../../assets/svg/to-quick-actions-close-btn.svg">
  </div>
  <span class="project-name">{{cardData?.project.name}}</span>
  <ng-container *ngIf="quickActionData; else loading">
    <span class="user-label">{{'project_team_dashboard_edit_team_leader_label' | translate}}</span>
    <div class="project-manager-container">
      <img class="leader-icon"
           [src]="(cardData?.project.leader.user?.avatar?.path !== null) ?
                   baseUrl+cardData?.project.leader.user.avatar.path : '../../../assets/svg/user-icon.svg'">
      <span class="leader-name-text edit-team-name-text">
        {{(cardData?.project.leader.user.detail.firstname || cardData?.project.leader.user.detail.lastname) ?
          cardData?.project.leader.user.detail.firstname+' '+cardData?.project.leader.user.detail.lastname :
          cardData?.project.leader.user.email}}</span>
    </div>
    <div class="status-and-frequency-container">
      <span class="label-text">{{'project_team_dashboard_edit_team_loop_label' | translate}}</span>
      <div *ngIf="quickActionData.projectDetails.projectFrequency" class="project-frequency-con">
          <span style="font-size: 1rem;color: #858DA2;">{{('project_team_dashboard_edit_team_frequency' | translate)}}</span>
          <span style="font-size: 1rem;color: #000000;">{{quickActionData.projectDetails.projectFrequency.name}}</span>
      </div>
    </div>
    <div class="project-status-container" [ngStyle]="{'border': '1px solid '+quickActionData.projectDetails.activity.color}">
        <div *ngIf="!quickActionData.projectDetails.activity?.isCompleted || !quickActionData.projectDetails.activity.isArchived" class="dot-status-color" [ngStyle]="{'background-color':quickActionData.projectDetails.activity.color}"></div>
        <span class="status-text" [ngStyle]="{'color':quickActionData.projectDetails.activity.color}">{{quickActionData.projectDetails.activity.title | uppercase}}</span>
        <img *ngIf="quickActionData.projectDetails.activity?.isCompleted" src="../../../../assets/svg/check-green.svg">
        <span *ngIf="!quickActionData.projectDetails.activity?.isCompleted && !quickActionData.projectDetails.activity.isArchived && !quickActionData.projectDetails.activity.isPaused" class="status-end-text">{{('project_team_dashboard_status_text' | translate:{date:(quickActionData.projectDetails.endDate.date | date:'dd MMM yyyy')})}}</span>
    </div>
    <span class="label-text">{{'project_team_dashboard_edit_team_loop_start_date' | translate}}</span>
    <div class="edit-team-date-container">
        {{quickActionData.projectDetails.startDate.date | date:'EEE, dd.M.yyyy'}}
    </div>
    <span class="label-text">{{'project_team_dashboard_edit_team_loop_deadline' | translate}}</span>
    <div class="edit-team-date-container">
        <span>{{quickActionData.projectDetails.endDate.date | date:'EEE, dd.M.yyyy'}}</span>
    </div>
    <span class="label-text">{{'PHASE'}}</span>
    <div class="edit-team-date-container">
        <span>{{quickActionData.projectDetails.phase.title}}</span>
    </div>
    <div *ngIf="!quickActionData.projectDetails.activity?.isCompleted" class="edit-team-pause-btn" (pointerdown)="$event.stopPropagation();" (click)="(quickActionData.projectDetails.status === 'active' || quickActionData.projectDetails.status === 'draft') ? pauseOrResumeProject('pause', quickActionData.projectDetails):pauseOrResumeProject('resume', quickActionData.projectDetails)">
        <img *ngIf="quickActionData.projectDetails.status === 'active'|| quickActionData.projectDetails.status === 'draft'" src="../../../../assets/svg/pause-circle-icon-blue.svg">
        <i *ngIf="quickActionData.projectDetails.status === 'inactive' || quickActionData.projectDetails.status === 'paused'" class="bi bi-play-circle-fill start-project-icon"></i>
        <span>{{((quickActionData.projectDetails.status === 'active'|| quickActionData.projectDetails.status === 'draft') ? 'project_team_dashboard_edit_team_pause_project':'project_team_dashboard_edit_team_start_project') | translate}}</span>
    </div>
    <span class="user-label">{{'project_team_dashboard_edit_team_team_members_label' | translate}}</span>
    <div class="members-main-container">
      <div class="edit-team-leader" [ngStyle]="{'margin-bottom':'.6rem'}" *ngFor="let member of quickActionData.members">
        <img class="leader-icon" [src]="(member.user?.avatar?.path !== null) ? baseUrl+member.user.avatar.path : '../../../assets/svg/user-icon.svg'">
        <span class="leader-name-text edit-team-name-text">{{(member.user.detail.firstname || member.user.detail.lastname) ? member.user.detail.firstname+' '+member.user.detail.lastname : member.user.email}}</span>
        <i class="bi bi-postcard project-member-email-icon" pTooltip="{{member.user.email}}" tooltipPosition="bottom" alt="email" (click)="copyEmailToClipboard(member.user.email)"></i>
        <img class="remove-project-member-icon" src="../../../../../assets/svg/icon-delete.svg" alt="remove-member" (click)="removeProjectMemberModal(member)">
    </div>
    </div>
  </ng-container>
  <ng-template #loading>
    <div class="spinner-border text-primary categ-statement-spinner" role="status"></div>
  </ng-template>
</div>
